import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { DSJ_ELIGIBILITY_RESULTS_HASH } from "../Common/Constants";
export var setRegisterURL = function setRegisterURL(redirectPath, data) {
  var registerURL = new URL('/register', window.location.origin);
  registerURL.searchParams.append('redirect_to', redirectPath);
  registerURL.searchParams.append('profile', JSON.stringify(data));
  registerURL.searchParams.append('signup_source', 'cef');
  window.location.assign(registerURL.toString());
};
export var setApplicationURL = function setApplicationURL(applicationId) {
  var applicationsURL = null;
  if (applicationId && Number.isInteger(Number(applicationId))) {
    applicationsURL = new URL("/applications/".concat(applicationId), window.location.origin);
  } else {
    applicationsURL = new URL('/my_applications', window.location.origin);
    console.error('applicationId must be a valid integer.'); // TODO: Report this error once we have the infrastructure to do so.
  }
  window.location.assign(applicationsURL.toString());
};
export var getDsjResultsRedirectPath = function getDsjResultsRedirectPath() {
  return "".concat(window.location.pathname).concat(DSJ_ELIGIBILITY_RESULTS_HASH);
};
export var removeHashFromURL = function removeHashFromURL() {
  window.history.replaceState('', '', "".concat(window.location.pathname).concat(window.location.search));
};